export { default } from './ExpoAppleWalletModule';